import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "BudgetModalCreate",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {
        tab_sichtbar: false,
      },
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "bud_kbez",
            type: "text",
            label: "_LBL_BUDGET_TABLE_MODAL_CREATE_KURZ_BEZEICHNUNG_",
            required: true,
            maxlength: 60,
            view: "v",
            translate: true,
          },
          {
            id: "bud_betrag",
            type: "currency",
            label: "_LBL_BUDGET_TABLE_MODAL_CREATE_BETRAG_",
            required: true,
            view: "v",
            translate: true,
          },
          {
            id: "bud_bez",
            type: "richtext",
            label: "_LBL_BUDGET_TABLE_MODAL_CREATE_BESCHREIBUNG_",
            maxlength: 1000,
            view: "v-alt",
            translate: true,
          },
        ],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  methods: {
    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);
      this.postHttp({ url: `budgets/`, data }).then(
        response => {
          this.addNotification({ text: "_MSG_BUDGET_TABLE_MODAL_CREATE_SUCCESS_" });
          this.close();
          this.$goTo("root.budget.details", { id: response.pk });
        },
        error => {
          this.errors = error.data;
          this.errorsClone = error.data;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
